export default __webpack_public_path__ + "static/media/DistrictNursingv3.0.9220804Communitynursingreferralguidelinev3_0_9_Page_8.5ad65396.jpg";